// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { isAdmin } from 'utils/common';

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
  const userIsAdmin = isAdmin();

  // 递归按 isAdmin 过滤,支持 collapse 嵌套分组;过滤后为空的分组自动隐藏
  const filterByAdmin = (children) =>
    children
      .filter((child) => !child.isAdmin || userIsAdmin)
      .map((child) => (child.children ? { ...child, children: filterByAdmin(child.children) } : child))
      .filter((child) => !child.children || child.children.length > 0);

  return (
    <>
      {menuItem.items.map((item) => {
        if (item.type !== 'group') {
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          );
        }

        const filteredChildren = filterByAdmin(item.children);

        if (filteredChildren.length === 0) {
          return null;
        }

        return <NavGroup key={item.id} item={{ ...item, children: filteredChildren }} />;
      })}
    </>
  );
};

export default MenuList;
